import {salesList} from "../../api/memberLevel";

const common = {
    state: {
        // 销售列表选项
        saleOption: [],
        addRouters: []
    },
    mutations: {
        SET_SaleOption: (state, saleOption) => {
            state.saleOption = saleOption;
        }
    },
    actions: {
        GenerateSaleOption({commit}, data) {
            return new Promise((resolve, reject) => {
                let saleOption = [];
                salesList().then(response => {
                    this.listLoading = false;
                    for (const responseElement of response.data) {
                        saleOption.push({
                            label: responseElement.nickName,
                            value: responseElement.nickName
                        })
                    }
                    commit('SET_SaleOption', saleOption)
                    resolve(saleOption)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
};

export default common;

